import { styled } from '@mui/material/styles';
import { Link, TableCell } from '@mui/material';
import { BlockRounded, Person, WarningRounded } from '@mui/icons-material';
import { getContrastColor } from '#component/theme';

export const LogsCell = styled(TableCell)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    paddingLeft: '4px !important'
  }
}));

export const EditCell = styled(TableCell)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    paddingLeft: '4px !important'
  }
}));

export const UserCell = styled('div')({
  maxWidth: '300px',
  minWidth: '200px',
  whiteSpace: 'pre-wrap'
});

export const DevicesTableCell = styled(TableCell)({
  width: '30%',
  minWidth: '30%',
  maxWidth: '30%',
  whiteSpace: 'pre-wrap'
});

export const PersonIcon = styled(Person)(({ theme }) => ({
  color: getContrastColor(),
  verticalAlign: 'middle',
  marginRight: theme.spacing(),
  marginBottom: 2
}));

export const BlockedIcon = styled(BlockRounded)(({ theme }) => ({
  color: '#667',
  verticalAlign: 'middle',
  marginRight: theme.spacing(),
  marginBottom: 2
}));

export const WarningIcon = styled(WarningRounded)({
  color: '#FACE31',
  verticalAlign: 'middle',
  marginRight: 6,
  marginBottom: 2
});

export const NameTableCell = styled(TableCell)({
  whiteSpace: 'nowrap'
});

export const LinkStyle = styled(Link)({
  color: '#212121',
  textDecoration: 'none',
  borderBottom: '1px #212121 solid',
  paddingBottom: 1,
  '&:hover': {
    borderBottom: 'none'
  }
});
